"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "boolean": 'Aggregations',
  "byte": 'NumericAggregations',
  date: 'NumericAggregations',
  "double": 'NumericAggregations',
  "float": 'NumericAggregations',
  half_float: 'NumericAggregations',
  id: 'Aggregations',
  integer: 'NumericAggregations',
  keyword: 'Aggregations',
  "long": 'NumericAggregations',
  object: 'Aggregations',
  scaled_float: 'NumericAggregations',
  string: 'Aggregations',
  text: 'Aggregations',
  unsigned_long: 'NumericAggregations'
};
exports["default"] = _default;